import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { useAuthInit } from '@/hooks/useAuth'
import { PageSpinner } from '@/components/ui/Spinner'

export function AuthGuard() {
  useAuthInit()

  const { user, isLoading } = useAuthStore()

  if (isLoading) return <PageSpinner />
  if (!user) return <Navigate to="/login" replace />
  return <Outlet />
}
